import { render, staticRenderFns } from "./RequestsByDay.vue?vue&type=template&id=db8e1d64&"
import script from "./RequestsByDay.vue?vue&type=script&lang=js&"
export * from "./RequestsByDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports